import styled from "styled-components";
import { Variables } from "../../styles/Variables";

export const Content = styled.div`
  position: absolute;
  top: 70px;
  right: 0%;
  z-index: 3000;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 10px;
  width: 20%;
  box-shadow: 0 0 10px #000;
  border-radius: 10px;
  background-color: ${Variables.colorWhite};

  @media (max-width: ${Variables.maxMobile}) {
    width: 50%;
  }
`;
